<template>
    <div
        v-if="plans !== null"
        class="container-fluid adminPlansWrapper">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">サービスモデル一覧</div>
                    <div class="card-body pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @blur="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-3 mt-md-2 mb-2 mb-md-0 ml-0 ml-md-2 text-right">
<!-- @see https://github.com/sewii/Yokumiru/issues/670 -->
<!--                                    <button-->
<!--                                        type="button"-->
<!--                                        class="btn btn-yokumiru-orange"-->
<!--                                        @click="onClickAddBtn">サービスモデル追加-->
<!--                                    </button>-->
                                </div>
                            </div>
                        </div>

                        <div :class="{ 'u-loader u-loader--p5' : ! plans }">
                            <div v-if="plans">
                                <b-table
                                    hover
                                    striped
                                    responsive
                                    :items="plans"
                                    :fields="fields"
                                    :sort-by.sync="$store.state.adminPlans.sortBy"
                                    :sort-desc.sync="$store.state.adminPlans.sortDesc"
                                    @sort-changed="fetchPlans"
                                    class="table-bordered m-table">
                                    <template v-slot:cell(plan_type)="data">
                                        <div>{{ data.item.plan_type_label }}</div>
                                    </template>

                                    <template v-slot:cell(price)="data">
                                        <div v-if="Number(data.item.price) > 0">
                                            {{ data.item.price.toLocaleString() }}<span class="small">円</span>
                                        </div>
                                        <div v-else class="text-muted">-</div>
                                    </template>

                                    <template v-slot:cell(billing_target)="data">
                                        <div>{{ data.item.billing_target_label }}</div>
                                    </template>

                                    <template v-slot:cell(cycle_unit)="data">
                                        <div>{{ data.item.cycle_unit_label }}</div>
                                    </template>

                                    <template v-slot:cell(min_duration)="data">
                                        <div v-if="data.item.min_duration && data.item.min_duration > 0">
                                            <span>{{ data.item.min_duration }}</span><!--
                                         --><span v-if="data.item.cycle_unit === cycleUnits.daily" class="small">日</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(term_url)="data">
                                        <div class="term_url d-flex">
                                            <a :href="data.item.term_url" target="_blank">{{ data.item.term_url }}</a>
                                        </div>
                                    </template>

                                    <template v-slot:cell(medical_courses)="data">
                                        <div class="medical_courses">
                                            <template v-if="data.item.is_custom_medical_courses">
                                                {{ medicalCourseLabels(data.item.medical_courses) }}
                                            </template>
                                            <template v-else>
                                                すべて
                                            </template>
                                        </div>
                                    </template>

                                    <template v-slot:cell(remarks)="data">
                                        <div class="remarks">{{ data.item.remarks }}</div>
                                    </template>

                                    <template v-slot:cell(action)="data">
                                        <b-button
                                            type="button"
                                            class="btn btn-yokumiru-blue btn-sm m-2"
                                            @click="showModalServiceModelSetting(data.item)">
                                            編集
                                        </b-button>
                                    </template>
<!-- @see https://github.com/sewii/Yokumiru/issues/670 -->
<!--                                    <template v-slot:cell(links)="data">-->
<!--                                        <div v-if="helper.isDefaultPlan(data.item) || helper.isFlatRatePlan(data.item)">-->
<!--                                            <div class="pt-4 pb-3"></div>-->
<!--                                        </div>-->
<!--                                        <div-->
<!--                                            v-else-->
<!--                                            class="d-flex justify-content-center align-items-center">-->
<!--                                            <b-button-->
<!--                                                type="button"-->
<!--                                                variant="yokumiru-blue"-->
<!--                                                class="btn-sm m-2"-->
<!--                                                @click="onClickEditBtn(data.item)">-->
<!--                                                編集-->
<!--                                            </b-button>-->
<!--                                            <div-->
<!--                                                v-if="isUsing(data.item)"-->
<!--                                                v-b-tooltip.top-->
<!--                                                title="既に利用されているサービスモデルは削除できません"-->
<!--                                                tabindex="0">-->
<!--                                                <b-button-->
<!--                                                    type="button"-->
<!--                                                    variant="danger"-->
<!--                                                    class="btn btn-sm m-2 btnDeletePlan"-->
<!--                                                    style="pointer-events: none;"-->
<!--                                                    disabled>-->
<!--                                                    削除-->
<!--                                                </b-button>-->
<!--                                            </div>-->
<!--                                            <div v-else>-->
<!--                                                <b-button-->
<!--                                                    type="button"-->
<!--                                                    variant="danger"-->
<!--                                                    class="btn btn-sm m-2 btnDeletePlan"-->
<!--                                                    @click="onClickDeleteBtn(data.item)">-->
<!--                                                    削除-->
<!--                                                </b-button>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </template>-->
                                </b-table>

                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                        :total-rows="$store.state.adminPlans.total"
                                        :per-page="$store.state.adminPlans.per_page"
                                        v-model="$store.state.adminPlans.current_page"
                                        @change="fetchPlans">
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <admin-add-plan-modal :plans="plans"/>
        <admin-edit-plan-modal :plans="plans"/>
        <admin-delete-plan-modal/>
        <admin-service-model-setting-modal/>
    </div>
</template>

<script>
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'
import { mapMutations } from 'vuex'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            cycleUnits: constants.cycleUnits,
            plans: null,
            search: {
                freeword: '',
            },
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'name',
                    'label': 'サービスモデル名',
                    sortable: true,
                },
                {
                    'key': 'key',
                    'label': 'キー',
                    sortable: true,
                },
                {
                    'key': 'plan_type',
                    'label': '課金タイプ',
                    sortable: true,
                },
                {
                    'key': 'price',
                    'label': '金額',
                    sortable: true,
                },
                {
                    'key': 'cycle_unit',
                    'label': '課金単位',
                    sortable: false,
                },
                {
                    'key': 'billing_target',
                    'label': '課金対象',
                    sortable: false,
                },
                {
                    'key': 'min_duration',
                    'label': '最低利用期間',
                    sortable: true,
                },
                {
                    'key': 'term_url',
                    'label': '規約URL',
                    sortable: false,
                },
                {
                    'key': 'formrun_uid',
                    'label': 'フォームランUID',
                    sortable: false,
                },
                {
                    'key': 'medical_courses',
                    'label': '対象相談科',
                    sortable: false,
                },
                {
                    'key': 'remarks',
                    'label': '備考',
                    sortable: false,
                },
                {
                    'key': 'action',
                    'label': '',
                    sortable: false,
                },
                // @see https://github.com/sewii/Yokumiru/issues/670
                // {
                //     'key': 'links',
                //     'label': '',
                //     'class': 'text-center',
                //     sortable: false,
                // },
            ],
        }
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.$store.state.adminPlans.total < 1) {
                return ''
            }
            return `全${this.$store.state.adminPlans.total}件中 ${this.$store.state.adminPlans.from}～${this.$store.state.adminPlans.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchPlans()

        bus.$on('plan-added', this.fetchPlans)
        bus.$on('plan-edited', this.fetchPlans)
        bus.$on('plan-deleted', this.fetchPlans)
    },

    beforeDestroy: function () {
        bus.$off('plan-added')
        bus.$off('plan-edited')
        bus.$off('plan-deleted')
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminPlans/setQuery',
            setQueries: 'adminPlans/setQueries',
        }),

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminPlans) {
                    this.setQueries(data.adminPlans)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.freeword = this.$store.state.adminPlans.freeword
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchPlans(1)
        },

        /**
         * サービスモデル一覧取得
         *
         * @param {number|object} param
         */
        fetchPlans: async function (param = null) {
            this.plans = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.plans.endpoint.base

            axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.plans = data.data
                    this.setQueries(data.meta)
                })
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.$store.state.adminPlans

            if (paginate) {
                query += `page=${state.current_page}`
            }
            query += `&sort=${state.sortBy}`
            query += `&desc=${state.sortDesc}`

            if (state.freeword && state.freeword.length > 0) {
                query += `&freeword=${state.freeword}`
            }

            return query
        },

        medicalCourseLabels: function(medical_courses) {
            console.log("call medicalCourseLabels", medical_courses)
            const names = medical_courses.map((mc) => {
                return mc.name
            })
            return names.join('、')
        },

        /**
         * 利用中のサービスモデルかどうか
         * @param {object} plan
         * @return {boolean}
         */
        isUsing: function (plan) {
            return plan.users_count > 0
                || plan.groups_count > 0
                || plan.with_trashed_subscriptions_count > 0
                || constants.plans.common.includes(plan.key)
        },

        // /**
        //  * サービスモデル追加ボタン押下時
        //  */
        // onClickAddBtn: function () {
        //     bus.$emit('open-modal-admin-add-plan')
        // },

        // /**
        //  * サービスモデル編集ボタン押下時
        //  * @param {object} plan
        //  */
        // onClickEditBtn: function (plan) {
        //     bus.$emit('open-modal-admin-edit-plan', plan)
        // },

        // /**
        //  * サービスモデル削除ボタン押下時
        //  * @param {object} plan
        //  */
        // onClickDeleteBtn: function (plan) {
        //     bus.$emit('open-modal-admin-delete-plan', plan)
        // },

        /**
         * サービスモデル設定モーダル表示
         *
         * @param {object} plan
         */
        showModalServiceModelSetting: function (plan) {
            bus.$emit('open-modal-admin-service-setting', plan)
        },
    },
};
</script>

<style lang="scss">
.adminPlansWrapper {
    .b-table {
        min-width: 1800px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>

<style scoped lang="scss">
.term_url {
    overflow-x: scroll;
    white-space: pre;
    width: 140px;
    padding: 5px 0;
    box-sizing: border-box;
    line-height: 0.8;
}

.medical_courses {
    overflow-x: scroll;
    white-space: nowrap;
    width: 140px;
    padding: 5px 0;
    box-sizing: border-box;
    line-height: 0.8;
}

.remarks {
    width: 140px;
}

.btnDeletePlan {
    min-width: 46px;
}
</style>
